/**
 * This component will restrict the focus on a specific area of the viewport
 * When the component will be unmounted we will restore the focus on the previous active element
 */
import React, { PureComponent } from 'react';
import $ from 'bianco.query';
import { add as addEvent, remove as removeEvent } from 'bianco.events';
import PropTypes from 'prop-types';
import { TAB } from 'util/dom/key-codes';
import { noop } from 'lodash';
import isElementVisible from 'util/dom/is-element-visible';

const MAX_TABINDEX = 1000;

export default class Aria51 extends PureComponent {
    static propTypes = {
        getRoot: PropTypes.func.isRequired,
        isActive: PropTypes.bool.isRequired,
        element: PropTypes.string.isRequired,
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    };

    static defaultProps = {
        element: 'div',
        isActive: true,
        getRoot: noop,
    };

    componentWillMount() {
        if (this.props.isActive) {
            this.lastElementFocused = document.activeElement;
        }
    }

    componentDidMount() {
        const { isActive } = this.props;
        this.props.getRoot(this.refs.root);
        if (isActive) {
            this.autofocus();
            this.addEvent();
        }
    }

    componentWillReceiveProps({ isActive }) {
        if (isActive && !this.props.isActive) {
            this.addEvent();
            this.autofocus();
        }

        if (this.props.isActive && !isActive) {
            this.removeEvent();
            this.updateIframes(true);
        }
    }

    componentWillUnmount() {
        const { isActive } = this.props;
        this.updateIframes(true);
        this.removeEvent();

        if (this.lastElementFocused && isActive) {
            this.lastElementFocused.focus();
        }
    }

    onElementFocus = (e) => {
        const { isActive } = this.props;

        if (isActive && !this.refs.root.contains(document.activeElement) && e.keyCode && e.keyCode === TAB) {
            e.preventDefault();
            this.firstFocusableElement.focus();
        }
    };

    removeEvent() {
        removeEvent(window, 'keyup', this.onElementFocus);
    }


    addEvent() {
        addEvent(window, 'keyup', this.onElementFocus);
    }

    updateIframes = (enable) => {
        $('iframe').forEach(iframe => {
            if (enable) {
                iframe.removeAttribute('tabindex');
            } else {
                iframe.setAttribute('tabindex', '-1');
            }
        });
    };

    autofocus() {
        this.updateIframes(false);
        this.firstFocusableElement.focus();
    }

    lastElementFocused = null;

    get firstFocusableElement() {
        const focusableElements = $('input, textarea, button, a', this.refs.root)
            // filter only the visible ones
            .filter(el => isElementVisible(el, this.refs.root))
            // sort the elements via tabIndex
            .sort((el1, el2) => {
                const tabIndex1 = +(el1.tabIndex || MAX_TABINDEX);
                const tabIndex2 = +(el2.tabIndex || MAX_TABINDEX);

                if (tabIndex1 < tabIndex2) {
                    return -1;
                } else if (tabIndex1 > tabIndex2) {
                    return 1;
                }

                return 0;
            });

        if (focusableElements.length) {
            return focusableElements[0];
        }

        return this.refs.root;
    }

    render() {
        const { element, isActive, children, getRoot, ...rest } = this.props; // eslint-disable-line
        return (
            <this.props.element {...rest} ref="root">
                {children}
            </this.props.element>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/aria-51/index.js